export const norm = (val) =>
  typeof val === "string" ? val.trim() : String(val ?? "").trim();

export const COMPONENT_ABBREVIATIONS = {
  "2:1 S.E Head (L/B)": "SE",
  "2:1 S.E Head (R/T)": "SE",
  "Flat Round Head (L/B)": "FR",
  "Flat Round Head (R/T)": "FR",
  "Flat Rectangular Head (L/B)": "RECT",
  "Flat Rectangular Head (R/T)": "RECT",
  "Cylindrical Shell": "CS",
  "Conical Shell": "CONE",
};

export function getComponentAbbreviation(component) {
  return COMPONENT_ABBREVIATIONS[norm(component)] || "";
}

export function computeShellUID(component, projectTag) {
  const tag = norm(projectTag);
  const abbr = getComponentAbbreviation(component);
  if (!tag || !abbr) return "";
  return `${tag}-${abbr}`;
}

export function computeNozzleUID(mark, projectTag) {
  const tag = norm(projectTag);
  const m = norm(mark);
  if (!tag || !m) return "";
  return `${tag}-${m}`;
}
